import React from 'react';
import { Typography, Button } from 'antd';
import styled from 'styled-components';
import { LockOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import { FEATURE_HOMES } from '../constants/featureHomes';

const { Title, Text } = Typography;

const Page = styled.div`
  min-height: 100vh; display: flex; align-items: center; justify-content: center;
  background: var(--odin-bg); padding: 24px;
`;
const Card = styled.div`
  max-width: 560px; width: 100%; padding: 40px; text-align: center;
  background: var(--odin-surface-elevated); border: 1px solid var(--odin-border);
  border-radius: 12px;
`;
const Groups = styled.ul`
  text-align: left; margin: 16px auto 0; padding-left: 20px; color: var(--odin-text-secondary);
`;

/** `/` for a signed-in person whose token carries no ODIN role (spec 2026-10-06 §4.3). */
export default function NoAccessPage() {
  const { user, logout } = useAuth();
  return (
    <Page>
      <Card>
        <LockOutlined style={{ fontSize: 40, color: 'var(--odin-accent-text)' }} />
        <Title level={2} style={{ color: 'var(--odin-text-primary)', margin: '16px 0 8px' }}>
          No ODIN features yet
        </Title>
        <Text style={{ color: 'var(--odin-text-secondary)' }}>
          {user?.email ? `${user.email} is signed in, but ` : ''}no feature group includes you.
          Ask for the group you need, then sign out and back in:
        </Text>
        <Groups>
          {FEATURE_HOMES.map((h) => (
            <li key={h.key}><strong style={{ color: 'var(--odin-text-primary)' }}>{h.label}</strong>: {h.group}</li>
          ))}
        </Groups>
        <Button style={{ marginTop: 24 }} onClick={logout}>Sign out</Button>
      </Card>
    </Page>
  );
}
